export default class {
    constructor(type) {
        this.namespaced = true;

        this.state = {
            type: type,
            addresses: [],
            countries: [],
            address: window?.data?.order?.[type] ?? {},
            save: false,
        };

        this.getters = {
            zone(state) {
                if (state.address.state) {
                    return state.address.state.zone;
                }

                if (state.address.country && !state.address.country.states.length) {
                    return state.address.country.zone;
                }

                return null;
            },
            completed(state) {
                return !!state.address
                    && !!state.address.id
                    || !!state.address
                    && !!state.address.firstName
                    && !!state.address.lastName
                    && !!state.address.tax
                    && !!state.address.email
                    && !!state.address.phone
                    && !!state.address.line1
                    && !!state.address.city
                    && !!state.address.zip
                    && !!state.address.country
                    && (!state.save || !!state.address.name);
            },
            form(state) {
                return {
                    id: state.address.id,
                    name: state.save ? state.address.name : undefined,
                    firstname: state.address.firstName,
                    lastname: state.address.lastName,
                    company: state.address.company,
                    tax: state.address.tax,
                    email: state.address.email,
                    phone: state.address.phone,
                    line1: state.address.line1,
                    line2: state.address.line2,
                    city: state.address.city,
                    zip: state.address.zip,
                    country_id: state.address.country.id,
                    state_id: state.address.state?.id,
                    notes: state.address.notes,
                };
            },
        };

        this.actions = {
            loadAddresses({commit, state}) {
                api.address.index(state.type).then(
                    response => commit('setAddresses', response.data.data)
                )
            },
            loadCountries({commit}) {
                api.country.index().then(
                    response => commit('setCountries', response.data.data)
                )
            },
        };

        this.mutations = {
            setAddresses(state, addresses) {
                state.addresses = addresses;
            },
            setCountries(state, countries) {
                state.countries = countries;
            },
            setAddress(state, address) {
                state.address = address;
            },
            setFirstName(state, firstName) {
                state.address.firstName = firstName;
            },
            setLastName(state, lastName) {
                state.address.lastName = lastName;
            },
            setCompany(state, company) {
                state.address.company = company;
            },
            setTax(state, tax) {
                state.address.tax = tax;
            },
            setEmail(state, email) {
                state.address.email = email;
            },
            setPhone(state, phone) {
                state.address.phone = phone;
            },
            setLine1(state, line1) {
                state.address.line1 = line1;
            },
            setLine2(state, line2) {
                state.address.line2 = line2;
            },
            setCity(state, city) {
                state.address.city = city;
            },
            setZip(state, zip) {
                state.address.zip = zip;
            },
            setState(state, countryState) {
                state.address.state = countryState;
            },
            setCountry(state, country) {
                state.address.country = country;
            },
            setNotes(state, notes) {
                state.address.notes = notes;
            },
            setSave(state, save) {
                state.save = save;
            },
            setName(state, name) {
                state.address.name = name;
            },
        };
    }
}
